import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 156.73 83.36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 156.73 83.36\" id=\"arrow\">\r\n\t<defs>\r\n\t\t<style>\r\n\t\t\t#arrow .cls-1 {\r\n\t\t\t\tfill: none;\r\n\t\t\t\tstroke-linecap: round;\r\n\t\t\t\tstroke-linejoin: round;\r\n\t\t\t\tstroke-width: 10px;\r\n\t\t\t}\r\n\r\n\t\t</style>\r\n\t</defs>\r\n\t<polyline class=\"cls-1\" points=\"151.73 5 78.36 78.36 5 5\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol